import React from 'react'

import {ROLES} from './config/constants'

import truncateString from './data/formatters/truncate_string'
import isUserExpert from './data/helpers/is_user_expert'

import ExpertRating from './expert_rating'
import ExpertSessionsCount from './expert_sessions_count'

class UserItemInfo extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      shouldShowSpecialtyTooltip: false
    }

    this.onShowSpecialtyTooltip = this.onShowSpecialtyTooltip.bind(this)
    this.onHideSpecialtyTooltip = this.onHideSpecialtyTooltip.bind(this)
  }

  onShowSpecialtyTooltip () {
    this.setState({shouldShowSpecialtyTooltip: true})
  }

  onHideSpecialtyTooltip () {
    this.setState({shouldShowSpecialtyTooltip: false})
  }

  renderExpertRating () {
    if (this.props.ratingEnabled && this.props.user.rating) {
      return <ExpertRating rating={this.props.user.rating} margin={this.props.ratingMargin} display='inline-block' />
    }
  }

  renderSessionsCount () {
    if (this.props.sessionsCountEnabled) {
      return <ExpertSessionsCount uid={this.props.user.uid} marginLeft={10} />
    }
  }

  renderExpertFields () {
    if (this.props.user.role === ROLES.EXPERT && (this.props.ratingEnabled || this.props.sessionsCountEnabled)) {
      return (
        <div>
          {this.renderExpertRating()}
          {this.renderSessionsCount()}
        </div>
      )
    }
  }

  renderSpecialtyTooltip () {
    if (this.state.shouldShowSpecialtyTooltip) {
      return (
        <div style={{background: 'rgba(30, 30, 30, .9)', fontSize: 11, lineHeight: '1.2em', padding: 5, position: 'absolute', top: 30, zIndex: 10, left: 0, borderRadius: 4, color: '#F0F0F0'}}>
          {this.props.user.specialty}
        </div>
      )
    }
  }

  renderExpertSpecialty () {
    if (this.props.specialtyEnabled && isUserExpert(this.props.user.role) && this.props.user.specialty) {
      let className = 'expert-sepecialty'
      if (this.props.threeLineSpecialty) className += ' three-line-text'

      return (
        <div style={{position: 'relative'}} onMouseEnter={this.onShowSpecialtyTooltip} onMouseLeave={this.onHideSpecialtyTooltip}>
          <div className={className} style={{fontSize: 12, fontWeight: 'bold', lineHeight: '1.2em', height: this.props.specialtyHeight, overflowY: 'hidden'}}>
            Expert in: {this.props.user.specialty}
          </div>
          {this.renderSpecialtyTooltip()}
        </div>
      )
    }
  }

  renderUserName (name) {
    if (this.props.truncateTo) return truncateString(name, this.props.truncateTo)

    return name
  }

  render () {
    let userNameClassName = 'name'

    if (this.props.twoLineName) userNameClassName += ' two-line-expert-text'
    else if (this.props.freeLineName) userNameClassName += ' free-line-expert-text'
    else userNameClassName += ' one-line-text'

    const whiteSpace = this.props.shouldFixLineClamp ? 'initial' : ''

    return (
      <div className={'user-item-info ' + this.props.className} style={this.props.style}>
        <h4 className={userNameClassName} style={{color: this.props.usernameColor || this.props.usernameStyle.color, fontSize: this.props.usernameStyle.fontSize, fontWeight: this.props.usernameStyle.fontWeight, whiteSpace}}>
          {this.renderUserName(this.props.user.name)}
        </h4>
        {this.renderExpertFields()}
        {this.renderExpertSpecialty()}
      </div>
    )
  }
}

UserItemInfo.defaultProps = {
  ratingEnabled: false,
  sessionsCountEnabled: false,
  specialtyEnabled: false,
  specialtyHeight: '2.5em',
  usernameStyle: {color: '#212121'}
}

export default UserItemInfo



/** WEBPACK FOOTER **
 ** ./modules/shared/user_item_info.js
 **/